import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    // Only scroll to top if the pathname actually changed (not just search params or hash)
    if (prevPathname.current !== pathname) {
      // Add a small delay to prevent interference with form interactions
      const timeoutId = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 50);
      
      prevPathname.current = pathname;
      
      // Cleanup timeout if component unmounts
      return () => clearTimeout(timeoutId);
    }
  }, [pathname]);

  return children || null;
};

export default ScrollToTop;
